import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';

const routes: CustomRoute = {
	path: '/unsubscribe',
	components: () => [],
	render: (_, children) => children,
	onEnter: async () => {},
	children: [
		{
			path: '',
			components: () => [import(/* webpackChunkName: 'unsubscribe' */ './component')],
			render: ([Unsubscribe]) => <Unsubscribe />,
			onEnter: async ({ next }) => {
				console.log('on Enter unsubscribe');
				await next();
				console.log('on Enter unsubscribe / end');
			},
		},
	],
};

export default routes;
